import AuxiliarCompras from '../../../../Utiles/Compra/AuxiliarCompras';
export default class AuxiliarOrden extends AuxiliarCompras {
    nuevo = true;
    ordenes = 'Copiar';
}